import { render, staticRenderFns } from "./fullScreen.vue?vue&type=template&id=2d82875b&scoped=true"
import script from "./fullScreen.vue?vue&type=script&lang=js"
export * from "./fullScreen.vue?vue&type=script&lang=js"
import style0 from "./fullScreen.vue?vue&type=style&index=0&id=2d82875b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82875b",
  null
  
)

export default component.exports